import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@app/environment/environment';
import { ProjectAdminIdea } from '@app/models/admin.model';
import { Project } from '@app/models/project.models';
import { PaginatedData } from '@app/models/shared.models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private readonly API_URL = environment.apiUrl + '/Project/Own';
  private http = inject(HttpClient);

  getAllOwnProjects(): Observable<PaginatedData<Project>> {
    return this.http.get<PaginatedData<Project>>(`${this.API_URL}`);
  }

  getOwnProjectIdeas(): Observable<PaginatedData<ProjectAdminIdea>> {
    return this.http.get<PaginatedData<ProjectAdminIdea>>(
      `${this.API_URL}/Ideas`
    );
  }
}
